/* Product-page dosing helper + sticky add-to-cart.
   Dose tables mirror sections/pet-dosage-calculator.liquid — keep in sync. */
(function () {
  'use strict';

  /* ---------------- Dosing helper ---------------- */

  var DOG_TABLE = [
    { max: 10, avg: 5, strong: 7 },
    { max: 20, avg: 10, strong: 14 },
    { max: 30, avg: 15, strong: 21 },
    { max: 40, avg: 20, strong: 28 },
    { max: 50, avg: 25, strong: 35 },
    { max: 60, avg: 30, strong: 42 },
    { max: 70, avg: 35, strong: 49 },
    { max: 80, avg: 40, strong: 56 }
  ];

  var CAT_TABLE = [
    { max: 10, avg: 4.2, strong: 8.4 },
    { max: 25, avg: 8.4, strong: 12.6 },
    { max: 40, avg: 12.6, strong: 16.8 },
    { max: 55, avg: 16.8, strong: 21 }
  ];

  function lookupDose(animal, lbs) {
    var table = animal === 'cat' ? CAT_TABLE : DOG_TABLE;
    for (var i = 0; i < table.length; i++) {
      if (lbs <= table[i].max) return table[i];
    }
    return null;
  }

  /* Find "8.3mg … per serving" or "each treat delivers 31mg" in the product lede
     so the readout can translate mg into droppers/treats. Silently skips if absent. */
  function detectServing() {
    var lede = document.querySelector('.product__info-container .product__text');
    var text = lede ? lede.textContent : '';
    var m = text.match(/([\d.]+)\s*mg[^.]{0,80}?per\s+(serving|dropper|treat|chew)/i);
    if (!m) m = text.match(/each\s+(treat|chew)\s+delivers\s+([\d.]+)\s*mg/i);
    if (!m) return null;
    var mg = parseFloat(m[2] && /^[\d.]+$/.test(m[2]) && !/^[\d.]+$/.test(m[1]) ? m[2] : m[1]);
    var wordMatch = m[0].match(/serving|dropper|treat|chew/i);
    var unitWord = wordMatch ? wordMatch[0].toLowerCase() : 'serving';
    if (!mg || mg <= 0) return null;
    return { mg: mg, unit: unitWord };
  }

  function formatUnits(count, unit) {
    var quarters = Math.max(1, Math.round(count * 4));
    var whole = Math.floor(quarters / 4);
    var frac = { 1: '¼', 2: '½', 3: '¾' }[quarters % 4] || '';
    var label = (whole > 0 ? whole : '') + frac;
    if (!label) label = String(whole);
    var plural = quarters > 4 ? unit + 's' : unit;
    return '≈ ' + label + ' ' + plural;
  }

  function initDosing() {
    var root = document.querySelector('[data-product-dosing]');
    if (!root) return;
    var animal = root.getAttribute('data-animal');
    var slider = root.querySelector('[data-dose-slider]');
    var primaryOut = root.querySelector('[data-dose-primary]');
    var chipOut = root.querySelector('[data-dose-chip]');
    var weightOut = root.querySelector('[data-dose-weight]');
    var noteOut = root.querySelector('[data-dose-note]');
    var fill = root.querySelector('[data-dose-fill]');
    var serving = detectServing();

    function render(lbs) {
      if (weightOut) weightOut.textContent = lbs + ' lb';
      var dose = lookupDose(animal, lbs);
      if (!dose) {
        if (primaryOut) primaryOut.textContent = '—';
        if (chipOut) chipOut.hidden = true;
        if (noteOut) noteOut.textContent = 'For pets over the chart range, ask your vet for guidance.';
        return;
      }
      var mgText = (dose.avg % 1 === 0 ? dose.avg : dose.avg.toFixed(1)) + ' mg CBD';
      if (serving) {
        if (primaryOut) primaryOut.textContent = formatUnits(dose.avg / serving.mg, serving.unit);
        if (chipOut) {
          chipOut.textContent = '≈ ' + mgText + ' per day';
          chipOut.hidden = false;
        }
      } else {
        if (primaryOut) primaryOut.textContent = mgText;
        if (chipOut) {
          chipOut.textContent = 'per day · see the serving guide on your label';
          chipOut.hidden = false;
        }
      }
      if (noteOut) {
        noteOut.textContent = 'Up to ' + dose.strong + ' mg for extra support — start low and adjust gradually.';
      }
      if (fill && serving) {
        var frac = Math.min(1, dose.avg / serving.mg);
        fill.setAttribute('height', Math.round(34 * frac));
        fill.setAttribute('y', 24 + Math.round(34 * (1 - frac)));
      }
    }

    if (slider) {
      slider.addEventListener('input', function () {
        render(parseInt(slider.value, 10) || 1);
      });
      render(parseInt(slider.value, 10) || 1);
    }

    // Horse variant: serving pills instead of a slider
    root.querySelectorAll('[data-horse-type]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-horse-type]').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        var serving_ = btn.getAttribute('data-horse-type') === 'adult' ? '1 serving (30g)' : '½ serving (15g)';
        if (primaryOut) primaryOut.textContent = serving_;
        if (chipOut) {
          chipOut.textContent = 'per day, mixed into feed';
          chipOut.hidden = false;
        }
        if (noteOut) noteOut.textContent = 'Start low and adjust gradually.';
      });
    });
    var activePill = root.querySelector('[data-horse-type].is-active');
    if (activePill) activePill.click();
  }

  /* ---------------- Sticky add-to-cart ---------------- */

  function parseMoney(text) {
    var m = (text || '').match(/\$\s?(\d+(?:[.,]\d{1,2})?)/);
    return m ? parseFloat(m[1].replace(',', '')) : null;
  }

  // The selected card renders "<s>$45.00</s>$33.75" — the live price is
  // always the last money amount in its text.
  function parseLastMoney(text) {
    var m = (text || '').match(/\$\s?(\d+(?:[.,]\d{1,2})?)/g);
    return m ? parseFloat(m[m.length - 1].replace(/[$,\s]/g, '')) : null;
  }

  // Best-effort read of the Stay AI buybox's selected plan price. Supports
  // both the buy-box-extended widget (.stayai-*) and the classic buybox
  // (.rtx_*). Returns null (caller falls back to the server-rendered
  // variant price) on any surprise.
  function stayAiSelectedPrice() {
    try {
      var extended = document.querySelector('.stayai-purchase-label.is-selected');
      if (extended) return parseLastMoney(extended.textContent);

      var container = document.querySelector('[class*="rtx_container"]');
      if (!container) return null;
      var options = container.querySelectorAll('[class*="rtx_option"], [class*="rtx_button"]');
      var selected = null;
      options.forEach(function (el) {
        if (selected) return;
        var cls = el.className || '';
        var checked = el.getAttribute('aria-checked') === 'true' || el.querySelector('input:checked');
        if (/selected|active|checked/i.test(cls) || checked) selected = el;
      });
      if (!selected) return null;
      var sub = selected.querySelector('[class*="subheading"]') || selected;
      return parseMoney(sub.textContent);
    } catch (e) {
      return null;
    }
  }

  function initStickyBar() {
    var bar = document.querySelector('[data-product-sticky-bar]');
    if (!bar) return;
    var sectionId = bar.getAttribute('data-section');
    var realButton = document.getElementById('ProductSubmitButton-' + sectionId);
    if (!realButton) return;

    var cta = bar.querySelector('[data-sticky-atc]');
    var labelOut = bar.querySelector('[data-sticky-label]');
    var totalOut = bar.querySelector('[data-sticky-total]');
    var fallbackPrice = parseFloat(bar.getAttribute('data-fallback-price') || '') || null;

    function qty() {
      var input = document.querySelector('#Quantity-' + sectionId);
      var v = input ? parseInt(input.value, 10) : 1;
      return v > 0 ? v : 1;
    }

    var mainTotalOut = document.querySelector('[data-atc-total]');

    function refreshTotal() {
      var unit = stayAiSelectedPrice();
      if (unit == null) unit = fallbackPrice;
      if (unit == null) {
        if (totalOut) totalOut.textContent = '';
        if (mainTotalOut) mainTotalOut.textContent = '';
        return;
      }
      var total = unit * qty();
      var money = '$' + (total % 1 === 0 ? total : total.toFixed(2));
      if (totalOut) totalOut.textContent = '· ' + money;
      if (mainTotalOut && !realButton.disabled) mainTotalOut.textContent = '— ' + money;
    }

    function refreshDisabled() {
      var disabled = realButton.disabled || realButton.getAttribute('aria-disabled') === 'true';
      cta.disabled = disabled;
      if (labelOut) labelOut.textContent = disabled ? realButton.textContent.trim() : 'Add to cart';
      if (disabled) {
        if (totalOut) totalOut.textContent = '';
        if (mainTotalOut) mainTotalOut.textContent = '';
      } else {
        refreshTotal();
      }
    }

    cta.addEventListener('click', function () {
      realButton.click();
    });

    document.addEventListener('change', refreshTotal);
    document.addEventListener('click', function () {
      window.requestAnimationFrame(refreshTotal);
    });

    // Reveal once the real CTA has scrolled up out of view
    var observer = new IntersectionObserver(
      function (entries) {
        var pastCta = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', pastCta);
        bar.setAttribute('aria-hidden', pastCta ? 'false' : 'true');
        if (pastCta) refreshDisabled();
      },
      { rootMargin: '0px' }
    );
    observer.observe(realButton);

    refreshDisabled();
  }

  /* Compact potency line under the lede: "1000 mg total CBD · 8.3 mg per serving" */
  function initSpecLine() {
    var line = document.querySelector('[data-spec-line]');
    if (!line) return;
    var serving = detectServing();
    if (!serving) return;
    var out = line.querySelector('[data-spec-serving]');
    if (!out) return;
    var prefix = line.getAttribute('data-potency') ? '· ' : '';
    out.textContent = prefix + serving.mg + ' mg per ' + serving.unit;
    out.hidden = false;
    line.hidden = false;
  }

  function initAll() {
    initDosing();
    initStickyBar();
    initSpecLine();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
